import React from 'react';
import styled from 'styled-components';
import colors from 'utils/colors';

const FormSection = props => (
  <Section>
    <Wrapper>
      <Left>
        <Heading>
          <StepIcon>{props.stepIcon}</StepIcon>
          <HeadingInformation>
            {props.title}
            <Description>{props.description}</Description>
          </HeadingInformation>
        </Heading>
      </Left>
      <Right>{props.inputs}</Right>
    </Wrapper>
  </Section>
);

const Left = styled.div`
  width: 30%;
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1200px) {
    width: 100%;
    margin-bottom: 1rem;
  }
`;
const Right = styled.div`
  flex-grow: 2;
`;
const Section = styled.div`
  width: 100%;
  border-top: 1px solid #e8e8e8;
`;
const Wrapper = styled.div`
  display: flex;
  padding: 2rem;
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1200px) {
    flex-direction: column;
  }
`;
const Heading = styled.div`
  display: flex;
  flex-wrap: nowrap;
  font-size: 1.125rem;
  justify-content: flex-start;
  width: 100%;
  align-items: baseline;
  color: ${colors.gray};
`;
const StepIcon = styled.div`
  border: 1px solid ${colors.brandingAccent};
  border-radius: 50%;
  min-width: 30px;
  height: 30px;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  margin-right: 1rem;
  color: ${colors.brandingPrimary};
`;
const HeadingInformation = styled.div`
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between;
  width: 100%;
  letter-spacing: 1px;
`;
const Description = styled.div`
  color: ${colors.lightGray};
  font-size: 0.75rem;
  padding-top: 1rem;
  letter-spacing: 0px;
`;

export default FormSection;
